import type { StorePlugin, StorePluginOptions } from '../types';
import { buildCreatePersistentSlice, BuiltCreatePersistedSlice } from './buildCreatePersistentSlice';

type PersistPluginMethods = {
    createPersistentSlice: BuiltCreatePersistedSlice;
};

export function createPersistPlugin<ModuleName extends string>(): StorePlugin<ModuleName, PersistPluginMethods> {
    return (options: StorePluginOptions<ModuleName>) => ({
        createPersistentSlice: buildCreatePersistentSlice(options),
    });
}
